<template>
    <div>
        <div class="px-5">
            <div class="row">
                <div class=" btn-home col-md-12 d-flex justify-content-end">
                    <button type="button" class="btn btn-outline-main" @click="changePage('home')">
                        <i class="fas fa-home"></i> Atras
                    </button>
                </div>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center mt-4">
                <div id="div-cxc" class="card w-100">
                    <div class="text-center card-header text-white h4 bg-main">
                        <strong>ACTIVOS</strong>
                    </div>
                    <div class="card-body w-100">
                        <div class="row">
                            <div class="col-md-12 py-2">
                                <div class="row d-flex mx-0">
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 px-1 mb-2">
                                        <div class="input-group input-group">
                                            <span class="input-group-text small-text-select" id="basic-addon1">Categoría</span>
                                            <v-select
                                                id="serviceSelect"
                                                class="text-dark flex-grow-1"
                                                label="name"
                                                :options="subCa"
                                                placeholder="-- Seleccione --"
                                                v-model="selectedCategory"
                                                :reduce="(name) => name.id"
                                                @input="calculateData(7)"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 px-1">
                                        <div class="input-group input-group">
                                            <span class="input-group-text small-text-select" id="basic-addon1">Subcategoría</span>
                                            <v-select
                                                id="serviceSelect"
                                                class="text-dark flex-grow-1"
                                                label="name"
                                                :options="filteredSubCategories"
                                                placeholder="-- Seleccione --"
                                                v-model="selectedSubCategory"
                                                :reduce="(name) => name.id"
                                                @input="calculateData(7)"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row d-flex mx-0 mt-2">
                                    <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-xs-9 px-1 mb-2">
                                        <div class="input-group input-group">
                                            <span class="input-group-text text-white bg-main"
                                            ><i class="fas fa-search"></i
                                            ></span>
                                            <input
                                            @keyup="calculateData(7)"
                                            v-model="search"
                                            type="text"
                                            class="form-control form-control"
                                            placeholder="Buscar Nombre"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-3 btn-home px-1">
                                        <button
                                            type="button"
                                            class="btn btn-bm-noradius w-100"
                                            @click="mtdModalShow(0,null)"
                                        >
                                            <i class="fas fa-plus"></i> Nueva
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mt-1" id="content-timelinetable">
                                <table id="tb-cxc" class="table table-bordered border-main">
                                    <thead class="bg-main">
                                        <tr class=" table-th text-white text-center text-xs">
                                            <th class="table-th-number">N°</th>
                                            <!-- <th>COD. DE BARRAS</th> -->
                                            <th>CATEGORIA</th>
                                            <th>SUB CATEGORIA</th>
                                            <th>NOMBRE</th>
                                            <!-- <th>MARCA</th>
                                            <th>MODELO</th>
                                            <th>SERIE</th>
                                            <th class="table-th-acciones">TIEMPO DE DEP.</th>
                                            <th class="table-th-acciones">MONTO DE DEP.</th>
                                            <th class="table-th-number">STOCK</th> -->
                                            <th class="table-th-number">ESTADO</th>
                                            <th class="table-th-acciones">ACCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody class="border-main">
                                        <tr class="table-body text-center text-xs" v-if="cpData.length === 0">
                                            <td colspan="13" class="text-center">No hay registros</td>
                                        </tr>
                                        <tr class="table-body text-center text-xs" v-for="(item, index) in cpData" :key="index">
                                            <td>{{mtdNumber(index)}}</td>
                                            <!-- <td>{{item.barcode}}</td> -->
                                            <td> {{ item.subategorie && item.subategorie.categorie ? item.subategorie.categorie.name : '-' }}</td>
                                            <td>{{item.subategorie ? item.subategorie.name : '-'}}</td>
                                            <td style="font-size: 11px">{{item.name}}</td>
                                            <!-- <td>{{item.brand}}</td>
                                            <td>{{item.model}}</td>
                                            <td>{{item.serie ? item.serie : '-' }}</td>
                                            <td>{{item.depreciation_time ? item.depreciation_time : '-'}}</td>
                                            <td>{{item.depreciation_amount ? item.depreciation_amount : '-'}}</td>
                                            <td>{{item.stock ? item.stock : '-'}}</td> -->
                                            <td>
                                                <div id="state_speciality" v-if="item.state == 1">
                                                    <div class="bg-success text-white">Activo</div>
                                                </div>
                                                <div id="state_speciality" v-else>
                                                    <div class="bg-secondary text-white">Inactivo</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="text-center d-flex justify-content-center">
                                                    <!-- <button class="btn btn-sm a-warning text-white" v-if="!item.technical_sheet" @click="mtduploadPdf(item)">
                                                        <i class="fas fa-upload"></i>
                                                    </button>
                                                    <button class="btn btn-sm a-warning text-white" v-if="item.technical_sheet" @click="openFile(item.technical_sheet)">
                                                        <i class="fas fa-file-pdf"></i>
                                                    </button> -->
                                                    <button
                                                        class="btn btn-sm a-success text-white" @click="mtdModalShow(1, item)">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button 
                                                        class="btn btn-sm a-danger text-white" @click="Datadetail(item.id ,2)">
                                                        <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Pag -->
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center mt-1">
                                <div v-if="cpData.length > 0" class="d-flex justify-content-center">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination mb-1">
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                                <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                            </li>
                                            <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
    
                                            <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                                <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                                </a>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                                <span class="page-link">...</span>
                                            </li>
                                            <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                                <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                                </a>
                                            </li>
                                            <li class="page-item">
                                                <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <cModalActivosVue :title="modal.title" :boo_modal="modal.modal_form" :num="modal.num" :payload="modal.payload"  :subCa="subCa"
        @closeModal="closeModal" @Datadetail="Datadetail"/>
        <cModalUpload :boo_modal="modal_upload.boo_modal" :title="modal_upload.title"  :id="modal_upload.id" @mtdcloseModal="mtdCloseUpload" @mtdInsert="mtdInsert"/>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </div>
</template>

<script>
import {
    mapActions
} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import cModalActivosVue from '../../modals/Mantenimiento/cModalActivos.vue'
import cModalUpload from "../../modals/Mantenimiento/cModalUpload.vue";
export default {
    name: "c-mantenedores-pages-activos",
    components: {
        SweetAlert,
        cModalActivosVue,
        cModalUpload
    },
    data() {
        return {
            swal: null,
            search:"",
            dataShow: [],
            dataAct: [],
            subCa: [],
            modal: {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            },
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
            action: "",
            //Select
            selectedCategory: null,
            selectedSubCategory: null,
            //Ficha
            modal_upload: {
                boo_modal: false,
                title: '',
                id: 0,
                page: "",
            }
        };
    },
    watch: {
        selectPage() {
            this.calculateData(7);
        },
        selectedCategory(newValue) {
            this.selectedSubCategory = null;
        }
    },
    computed: {
        classTh() {
            return 'align-middle border border-5 bg-main border-white';
        },
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },
        filteredSubCategories() {
            if (this.selectedCategory) {
                const selectedCategory = this.subCa.find(category => category.id === this.selectedCategory);
                return selectedCategory ? selectedCategory.subcategorie || [] : [];
            }else{
                this.selectedCategory = null,
                this.selectedSubCategory = null
            }
            return [];
        }
    },
    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        //Traer Data
        mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/Activos",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.dataAct = response.data.data;
                this.subCa = response.data.subCa;
                this.calculateData(7);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        calculateData(items) {
            if (!this.dataAct || !this.dataAct.length) {
                return (this.dataShow = []);
            }

            let filteredData = this.dataAct;
            let indexInitial = this.selectPage;

            if (this.selectedCategory) {
                filteredData = filteredData.filter(element => element.categorie_id == this.selectedCategory);
            } else {
                this.selectedSubCategory = null;
            }

            if (this.selectedSubCategory) {
                filteredData = filteredData.filter(element => element.subategory_id == this.selectedSubCategory);
            }

            if (this.search.length >= 2) {
                let query = this.search.toString().toUpperCase();
                filteredData = filteredData.filter((element) => {
                    let name = element.name.toString().toUpperCase();
                    return name.includes(query);
                });
                if (!filteredData.length && this.search === "") {
                    filteredData = this.dataAct;
                }

                indexInitial = 1;
            }

            let totalPages = Math.ceil(filteredData.length / items);

            this.stepPagination = Array.from(
                { length: totalPages },
                (_, index) => index + 1
            );

            if (this.selectPage > totalPages) {
                this.selectPage = totalPages || 1;
            }

            let startIndex = (this.selectPage - 1) * items;
            let endIndex = startIndex + items;
            this.dataShow = filteredData.slice(startIndex, endIndex);
            this.count = this.count + 1;
        },

        mtdModalShow: function (num, payload) {
            this.modal.title = (num == 0) ? 'Registrar Activo' : 'Editar Activo';
            this.modal.modal_form = true;
            this.modal.num = num;
            this.modal.payload = payload;
            //console.log(payload);
        },

        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            }
        },

        Datadetail: function (payload_detail, num_detail) {
            if (num_detail == 0) {
                payload_detail.action = 'c';
                this.addDatadetail(payload_detail, num_detail);
            } else if (num_detail == 1) {
                payload_detail.action = 'u';
                this.addDatadetail(payload_detail, num_detail);
            } else {
                let data = {
                    action : 'd',
                    id : payload_detail
                }

                this.$refs.SweetAlert.showConfirmSimple2("","¿Estás seguro?","warning","Eliminar") 
                .then((result) => {
                    if (result.value) {
                        this.addDatadetail(data, num_detail);
                    }
                });
            }
        },

        addDatadetail: function (payload_detail, num_detail) {
            /* let formData = new FormData();
            let depreciation_time = payload_detail.depreciation_time == null ? '' : payload_detail.depreciation_time;
            let depreciation_amount = payload_detail.depreciation_amount == null  ? '' : payload_detail.depreciation_amount;
            let stock = payload_detail.stock == null ? '' : payload_detail.stock;
            let serie = payload_detail.serie == null ? '' : payload_detail.serie;
            let state = payload_detail.state ? '1' : '0';
            formData.append("action", payload_detail.action);
            formData.append("id", payload_detail.id);
            formData.append("subsub_categorie_id", payload_detail.subsub_categorie_id);
            formData.append("name", payload_detail.name);
            formData.append("brand", payload_detail.brand);
            formData.append("model", payload_detail.model);
            formData.append("depreciation_time", depreciation_time);
            formData.append("depreciation_amount", depreciation_amount);
            formData.append("stock", stock);
            formData.append("barcode", payload_detail.barcode);
            formData.append("serie", serie);
            formData.append("file", payload_detail.technical_sheet);
            formData.append("state", state); */
            this.post({
                url: this.$store.getters.get__url + "/Activos/crudActivos",
                token: this.$store.getters.get__token,
                params: payload_detail,
            })
            .then(response => {
                if (num_detail == 2) {
                    this.$refs.SweetAlert.showSuccess("El registro ha sido eliminado");
                    this.action = payload_detail.action;
                    this.mtdGetData();
                } else {
                    this.$refs.SweetAlert.showSuccess(num_detail == 0 ? "Registro Exitoso" : "Modificación Exitosa");
                    this.closeModal()
                    this.mtdGetData();
                }
            })
            .catch(error => {
                this.$refs.SweetAlert.showError(error);
            })
        },

        //Ficha Tecnica
        mtduploadPdf: function (item) {
            this.modal_upload = {
                boo_modal: true,
                title: 'Subir Ficha Tecnica',
                id: item.id,
            };
        },

        mtdCloseUpload: function () {
            this.modal_upload = {
                boo_modal: false,
                title: "",
            };
        },
        
        mtdInsert: function (file, id) {
            let formData = new FormData();
            formData.append("file", file);
            formData.append("id", id);
            this.post({
                url: this.$store.getters.get__url + '/Activos/uploadFichaTecnica',
                token: this.$store.getters.get__token,
                params: formData,
            })
            .then((response) => {
                if (response.statusCode == 200) {
                    this.$refs.SweetAlert.showSuccess('Se subió el archivo Correctamente');
                    this.mtdGetData();
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        openFile: function (url) {
            window.open('assets/' + url, '_blank');
        },

        //Paginacion
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function(index){
            return (this.selectPage-1)*7 + (index + 1)
        },
        changePage(page) {
            this.$emit('changePage', page)
        },
    }
}
</script>